export const enHeaderTranslations = {
    HEADER__HELP_LINKS__DOCUMENTATION_LINK: 'Section Help',
    HEADER__HELP_LINKS__TITLE: 'Help',
    HEADER__HELP_LINKS__IDEA_BUTTON__TITLE: 'Ideas',
    HEADER__HELP_LINKS__LANGUAGE: 'Change language',
    HEADER__HELP_LINKS__VIDEO_LINK: 'Watch a video',
    HEADER__USER__TEXT__PROFILE: 'Profile',
    HEADER__USER__TEXT__NOTIFICATION: 'Notifications',
    HEADER__USER__TEXT__LOGOUT: 'Logout',
    HEADER__TARIFFS__TITLE: 'Plan',
};
